import { ResetMethodTab, UserIdentifyType } from "@/modules/auth/common/enum";
import { getResetMethodTabItems } from "@/modules/auth/helpers";
import { useIdentifyUserMutation } from "@/modules/auth/services";
import { setChallenge, setResetActiveTab, setVerificationId, } from "@/modules/auth/state";
import { useAppDispatch, useAppSelector, useMediaQuery, useNotify } from "@/shared/hooks";
import { Tab } from "@ab.uitools/ui-library/components/Tab";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { AccountNumberForm, CardNumberForm } from "./Form";

interface ISubmit {
  cardNumber?: string;
  accountNumber?: string;
}

export const AccountOrCardVerification = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const { showErrorAlertNotification } = useNotify();
  const [identifyUser, { isLoading }] = useIdentifyUserMutation();

  const activeTab = useAppSelector((state) => state.auth.resetActiveTab);

  const [activeMethod, setActiveMethod] = useState<string>(ResetMethodTab.Account);

  const changeResetMethod = (value: string) => {
    dispatch(setResetActiveTab(value));
    setActiveMethod(value);
  };

  const tabItems = getResetMethodTabItems({ t });

  const onSubmit = ({ accountNumber, cardNumber }: ISubmit) => {
    const data = {
      userIdentificationOption: accountNumber ? UserIdentifyType.Account : UserIdentifyType.Card,
      identifier: accountNumber || cardNumber || "",
    };

    identifyUser(data)
      .unwrap()
      .then((res) => {
        const verificationId = res?.id;
        dispatch(setVerificationId(verificationId));
        dispatch(setChallenge(res.challenge));
      })
      .catch((err) => {
        showErrorAlertNotification(err);
      });
  };

  useEffect(() => {
    if (activeTab) {
      setActiveMethod(activeTab);
    }
  }, []);

  const isMobile = useMediaQuery("(max-width: 393px)");

  return (
    <div className="full-width">
      <Tab
        tabItems={tabItems}
        type="secondary"
        size={isMobile ? "small" : "medium"}
        color="dark"
        className="full-width reset-password-tab mt-24"
        onSelect={(value) => changeResetMethod(value as string)}
        selectedValue={activeMethod}
      />
      {activeMethod === ResetMethodTab.Card ? (
        <CardNumberForm onSubmit={onSubmit} isLoading={isLoading}/>
      ) : (
        <AccountNumberForm onSubmit={onSubmit} isLoading={isLoading}/>
      )}
    </div>
  );
};
